import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { ActivityBadge } from 'components/sections/dashboard'
import { Image } from 'containers/misc'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import styles from './section-sub-header.styl'

export default class SectionSubHeader extends Component {
  static propTypes = {
    subtitle: PropTypes.any,
    title: PropTypes.any,
    isMajor: PropTypes.bool,
    completedPercentage: PropTypes.number,
    progress: PropTypes.object,
    tabs: PropTypes.object,
    activitySection: PropTypes.string,
    hasAvatar: PropTypes.bool
  }

  static defaultProps = {
    isMajor: false,
    activityType: null,
    activitySection: null,
    completedPercentage: null
  }

  render() {
    const {
      avatar,
      tabs,
      title,
      isMajor,
      subtitle,
      progress,
      activitySection,
      completedPercentage,
      hasAvatar
    } = this.props

    const activityType = getActivityClassName(activitySection)
    const classNames = [styles.wrap]

    activityType && classNames.push(styles[activityType])

    return (
      <div className={classNames.join(' ')}>
        {activitySection &&
        !hasAvatar && (
          <ActivityBadge
            activitySection={activitySection}
            large
            medal
            className={styles.badge}
          />
        )}
        {avatar &&
        hasAvatar && <Image className={styles.avatar} src={avatar} />}
        {!avatar &&
        hasAvatar && (
          <div className={styles.noAvatar}>
            <i className="ico ico--user" />
          </div>
        )}
        <div className={styles.content}>
          <p className={styles.title}>{title || <span>---</span>}</p>
          <p className={styles.subtitle}>
            {subtitle || <span>---</span>}
            {isMajor && (
              <span className={styles.major}>
                <FormattedMessage id="label.major" defaultMessage="Major" />
              </span>
            )}
          </p>

          <div className={styles.footer}>
            {completedPercentage !== null ? (
              <span className={styles.percentage}>
                {completedPercentage}
                <span className={styles.percentageSymbol}> %</span>
              </span>
            ) : (
              ''
            )}
            {progress && <div className={styles.progress}>{progress}</div>}
          </div>
        </div>

        <div className={styles.tabs}>{tabs}</div>
      </div>
    )
  }
}
